import { render, staticRenderFns } from "./MatchTargetItem.vue?vue&type=template&id=219d5458&scoped=true&"
import script from "./MatchTargetItem.vue?vue&type=script&lang=js&"
export * from "./MatchTargetItem.vue?vue&type=script&lang=js&"
import style0 from "./MatchTargetItem.vue?vue&type=style&index=0&id=219d5458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d5458",
  null
  
)

export default component.exports